import React from "react";

function Success({message}) {
    return (
        <div className="bg-gold-100 p-4 border-l-2 border-gold-500 text-gold-900">
            { message }
        </div>
    )
}

export default Success;
